import { render, staticRenderFns } from "./TagBadge.vue?vue&type=template&id=2c68d6ac&scoped=true"
import script from "./TagBadge.vue?vue&type=script&lang=js"
export * from "./TagBadge.vue?vue&type=script&lang=js"
import style0 from "./TagBadge.vue?vue&type=style&index=0&id=2c68d6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68d6ac",
  null
  
)

export default component.exports